<template>
    <TableDate :allData='tableData'  :name='name' :code='code' :toDetail='toDetail'/>
</template>
<script>
    import TableDate from './tableDate.vue';
    export default {
        components:{
            TableDate
        },
        props:{
            allData:{
                type:[Object,Array]
            },
            name:{
                type:String,
            },
            code:String,
            toDetail:Function,
        },
        data(){
            return {
                tableData:[]
            }
        },
        mounted() {
            if(this.allData){
                this.tableData = [...this.init(this.allData)];

            }
        },
        watch:{
        'allData':function(value,oldValue){
            if(value){
                this.tableData = [...this.init(this.allData)];
            }
        }
    },
        methods:{
            init(data){
                let z = {},t = {},y = {};
                z.all = '消费卡数（张）';
                t.all = '消费量（吨）';
                y.all = '消费额（万元）';
                let arr = ['time','yest','month','season','year','hist'];
                for(let i=0;i<6;i++){
                    switch(i){
                        case 0:
                            z[arr[i]] = {
                                all:data.provinceCurCountTotal,
                                in:data.thisProvinceCurCount,
                                out:data.otherProvinceCurCount,
                                section:data.dateRegion,
                            }
                            t[arr[i]] = {
                                all:data.provinceCurLitreTotal,
                                in:data.thisProvinceCurLitre,
                                out:data.otherProvinceCurLitre,
                            }
                            y[arr[i]] = {
                                all:data.consumeCurMoneyTotal,
                                in:data.thisConsumeCurMoney,
                                out:data.otherConsumeCurMoney,
                            }
                        break;
                        case 1:
                            z[arr[i]] = {
                                all:data.provinceCountTotal,
                                in:data.thisProvinceCount,
                                out:data.otherProvinceCount,
                                section:data.yesterdayDateRegion,
                            }
                            t[arr[i]] = {
                                all:data.provinceLitreTotal,
                                in:data.thisProvinceLitre,
                                out:data.otherProvinceLitre,
                            }
                            y[arr[i]] = {
                                all:data.consumeMoneyTotal,
                                in:data.thisConsumeMoney,
                                out:data.otherConsumeMoney,
                            }
                        break;
                        case 2:
                            z[arr[i]] = {
                                all:data.provinceMonthCountTotal,
                                in:data.thisProvinceMonthCount,
                                out:data.otherProvinceMonthCount,
                                section:data.monthDateRegion,
                            }
                            t[arr[i]] = {
                                all:data.provinceMonthLitreTotal,
                                in:data.thisProvinceMonthLitre,
                                out:data.otherProvinceMonthLitre,
                            }
                            y[arr[i]] = {
                                all:data.consumeMonthMoneyTotal,
                                in:data.thisConsumeMonthMoney,
                                out:data.otherConsumeMonthMoney,
                            }
                        break;
                        case 3:
                            z[arr[i]] = {
                                all:data.provinceQuarterCountTotal,
                                in:data.thisProvinceQuarterCount,
                                out:data.otherProvinceQuarterCount,
                                section:data.quarterDateRegion,
                            }
                            t[arr[i]] = {
                                all:data.provinceQuarterLitreTotal,
                                in:data.thisProvinceQuarterLitre,
                                out:data.otherProvinceQuarterLitre,
                            }
                            y[arr[i]] = {
                                all:data.consumeQuarterMoneyTotal,
                                in:data.thisConsumeQuarterMoney,
                                out:data.otherConsumeQuarterMoney,
                            }
                        break;
                        case 4:
                            z[arr[i]] = {
                                all:data.provinceYearCountTotal,
                                in:data.thisProvinceYearCount,
                                out:data.otherProvinceYearCount,
                                section:data.yearDateRegion,
                            }
                            t[arr[i]] = {
                                all:data.provinceYearLitreTotal,
                                in:data.thisProvinceYearLitre,
                                out:data.otherProvinceYearLitre,
                            }
                            y[arr[i]] = {
                                all:data.consumeYearMoneyTotal,
                                in:data.thisConsumeYearMoney,
                                out:data.otherConsumeYearMoney,
                            }
                        break;
                        case 5:
                            z[arr[i]] = {
                                all:data.provinceTotalCountTotal,
                                in:data.thisProvinceTotalCount,
                                out:data.otherProvinceTotalCount,
                                section:data.hisDateRegion,
                            }
                            t[arr[i]] = {
                                all:data.provinceTotalLitreTotal,
                                in:data.thisProvinceTotalLitre,
                                out:data.otherProvinceTotalLitre,
                            }
                            y[arr[i]] = {
                                all:data.consumeTotalMoneyTotal,
                                in:data.thisConsumeTotalMoney,
                                out:data.otherProvinceTotalCount,
                            }
                        break;
                        // default:
                        // break;
                    }
                }
                // for ( let i = 0; i<data.length; i++ ) {
                //     z[arr[i]] = {
                //         all:data[i].totalProvinceCard,
                //         in:data[i].inProvinceCard,
                //         out:data[i].outProvinceCard,
                //         section:data[i].timeSection,
                //     }
                //     t[arr[i]] = {
                //         all:data[i].totallitter,
                //         in:data[i].inProvincelitter,
                //         out:data[i].outProvincelitter,
                //     }
                //     y[arr[i]] = {
                //         all:data[i].totallitterAmount,
                //         in:data[i].inProvinceAmount,
                //         out:data[i].outProvinceAmount,
                //     }
                // };
                return [z,t,y]
            }
        }
    }
</script>
